export default {"src":"/_next/static/media/checkbox-mixed-disabled.2910ce2f.svg","height":20,"width":20};